module.exports = __webpack_public_path__ + "img/p4-c1-p1.e47b4b89.jpg";